import FeesServices from '@/modules/configuration/application/services/FeesServices'
import { mapState } from 'vuex'
import { EventBus } from '@/eventBus'
import KBMoney from '@/shared/infrastructure/ui/inputs/text/KBMoney.vue'
import KBText from '@/shared/infrastructure/ui/inputs/text/KBText.vue'
import KBButton from '@/shared/infrastructure/ui/buttons/KBButton.vue'
import BillingCommissionsCard from '@/modules/consumptions/infrastructure/ui/components/BillingCommissionsCard/BillingCommissionsCard.vue'
import { KeybeIconType } from '@/shared/infrastructure/enums/icons/KeybeIconType'
import KeybeIcon from '@/shared/infrastructure/ui/icons/KeybeIcon.vue'

export default {
  name: 'ReferralPayment',
  props: ['dataCards'],
  components: { BillingCommissionsCard, KBText, KBButton, KBMoney, KeybeIcon },
  data: function () {
    return {
      KeybeIconType,
      accountNumber: null,
      bank: null,
      idNumber: null,
      amount: null
    }
  },
  computed: {
    ...mapState('UserStore', ['user', 'userExtradata', 'darkMode']),
    userEmail (): string {
      return this.user?.email || ''
    }
  },
  watch: {
  },
  methods: {
    getlength (number) {
      return number.toString().length
    },
    validateForm () {
      if (this.accountNumber) {
        const valLength = this.getlength(this.accountNumber)
        if (valLength < 10 || valLength > 50) {
          EventBus.$emit('toast', 'error', `${this.$t('accountNumber')} - Min(10  ${this.$t('characters')}) Max (50  ${this.$t('characters')})`)
          return
        }
      } else {
        EventBus.$emit('toast', 'error', this.$t('msgErrorForm'))
        return
      }
      if (this.bank) {
        const valLength = this.getlength(this.bank)
        if (valLength < 5 || valLength > 50) {
          EventBus.$emit('toast', 'error', `${this.$t('informationBank')} - Min(5  ${this.$t('characters')}) Max (50  ${this.$t('characters')})`)
          return
        }
      } else {
        EventBus.$emit('toast', 'error', this.$t('msgErrorForm'))
        return
      }
      if (this.idNumber) {
        const valLength = this.getlength(this.idNumber)
        if (valLength < 8 || valLength > 50) {
          EventBus.$emit('toast', 'error', `${this.$t('idDocument')} - Min(8 ${this.$t('characters')}) Max (20  ${this.$t('characters')})`)
          return
        }
      } else {
        EventBus.$emit('toast', 'error', this.$t('msgErrorForm'))
        return
      }
      if (this.amount) {
        if (this.amount < 20) {
          EventBus.$emit('toast', 'error', `${this.$t('amount')} - Min (20 USD)`)
          return
        }
      } else {
        EventBus.$emit('toast', 'error', this.$t('msgErrorForm'))
        return
      }
      this.sendEmail()
    },
    async sendEmail () {
      try {
        const data = {
          accountNumber: this.accountNumber,
          bank: this.bank,
          id: this.idNumber,
          amount: parseInt(this.amount),
          email: this.userEmail
        }
        const invoices = await FeesServices.sendFeesEmail(data)
        if (invoices) {
          if (invoices.data?.statusCode === 404) {
            EventBus.$emit('toast', 'error', invoices.data?.message)
            return
          }
          if (invoices) {
            this.returnMain()
            EventBus.$emit('toast', 'success', this.$t('formSend'))
          }
        }
      } catch (error) {
      }
    },
    returnMain () {
      this.$parent.goback()
    }
  }
}
